module.exports = __webpack_public_path__ + "static/home-a038bb57955551dae2b3e7e56becc98f.png";